import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, role, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-paper">
        <div className="flex items-center gap-3 text-ink-soft">
          <span className="h-2.5 w-2.5 rounded-full bg-forest animate-pulse" />
          <span className="font-serif italic">Verificando sesión…</span>
        </div>
      </div>
    );
  }
  const allowed = roles || (role ? [role] : null);
  if (!user) {
    // Super-admin attempts should land on the dedicated phone-based login
    if (allowed?.includes("superadmin") && !allowed.includes("admin")) {
      return <Navigate to="/superadmin/login" state={{ from: location.pathname }} replace />;
    }
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (allowed && !allowed.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
